import moment from "moment";
import { getCurrentLocale } from "i18n/i18n";
import "moment/locale/pl";

export default (args) => {
  moment.locale(getCurrentLocale());
  return moment(args);
};
